/*
* Main App container
*/

import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as AppComp from './common/app-component-base';
import * as ReduxQueries from './queries';
import Footer from './footer';

import './App.css';

export class App extends AppComp.AppComponentNoWrapper<AppComp.IAppComponentProps, any> {

  public constructor(props: AppComp.IAppComponentProps) {
    super(props, 'app.app.');
  }

  public render() {
    const { children } = this.props;

    return (
      <div>
        {children}
        <Footer {...this.props} />
      </div>
    );
  }
}

const mapStateToProps = (state: AppComp.IAppComponentState, props): AppComp.IAppComponentProps =>
  ReduxQueries.MapQueryStateToPropsRoot(state, props, null);
export default withRouter<AppComp.IAppComponentProps>(connect(mapStateToProps, {})(App));



// WEBPACK FOOTER //
// ./src/App.tsx